<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div slot="header" class="title_head">Create Card
      </div>
      <b-collapse id="collapse1" visible>
        <b-card-body>
          <b-row>
            <!-- <div class="alert alert-success" v-if="haserror.message!=''" style="text-align:center;">{{haserror.message}}</div> -->
            <b-col sm="4">
              <b-form-group>
                <label for="name"> Shop Name </label>
                 <span style="display: flex;">
                  <model-list-select @input="onShpChange($event)" :list="shopname" option-value="est_shop_id" option-text="est_shop_name" v-model="select_shop" placeholder="Select Shop" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                   <small  class="form-text text-muted"><strong style="color: red;">{{haserror.shop}}</strong></small>
                <!-- <b-form-input
                  type="text"
                  placeholder="Enter Ledger No."
                  autocomplete="off"
                  v-model="cardData.ledgerno"
                ></b-form-input> -->
                 <button  type="button" @click="addShop()" class="btn btn-pill btn-primary" v-b-tooltip.hover title="Add New Shop"><i class="fa fa-plus"></i></button>
                  
                </span>
              </b-form-group>
                
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="name"> Scheme </label>
                  <model-list-select @input="onSchemeChange($event)" :list="schemelist" option-value="scheme_id" option-text="scheme_name" v-model="selectedscheme" placeholder="Select Scheme" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                   <small  class="form-text text-muted"><strong style="color: red;">{{haserror.scheme}}</strong></small>
                <!-- <b-form-input
                  type="text"
                  placeholder="Enter Ledger No."
                  autocomplete="off"
                  v-model="cardData.ledgerno"
                ></b-form-input> -->
              </b-form-group>
                
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="name"> Monthly Pay </label>
                <b-form-input
                  type="text"
                  placeholder="Monthly Pay"
                  autocomplete="off"
                  v-model="cardData.monthlypay"
  
                ></b-form-input>
              </b-form-group>
              <small  class="form-text text-muted"><strong style="color: red;">{{haserror.amount}}</strong></small>
            </b-col>
           
             <b-col sm="6">
               
              <b-form-group>
                <label for="name"> Customer Name </label>
                  <span style="display: flex;">
                 <model-list-select :list="customername" option-value="customer_id" :custom-text="nameAndnumber" v-model="selectedcustomer" placeholder="Search Customer Name" @input="onSelectCust($event)" @searchchange="searchcustomer" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                 <!-- <model-list-select :list="customername" option-value="customer_id" :custom-text="nameAndnumber" v-model="cardData.customername" placeholder="Search Customer Name" @input="onSelectCust($event)" @searchchange="searchcustomer" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select> -->
                <!-- <b-form-input
                  type="text"
                  placeholder="Enter your Customer Name"
                  autocomplete="off"
                  v-model="cardData.customername"
                ></b-form-input> -->
                 <button  type="button" class="btn btn-pill btn-primary" route v-b-tooltip.hover title="Add New Customer" @click="addCustomer()">
                     <i class="fa fa-user"></i>
                   </button>
                  </span>
              </b-form-group>
              <small  class="form-text text-muted"><strong style="color: red;">{{haserror.cust}}</strong></small>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="name"> Address </label>
                <b-form-input
                  type="text"
                  placeholder="Address"
                  autocomplete="off"
                  v-model="cardData.address"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
             <b-col sm="4">
              <b-form-group>
                <label for="name"> Opening Month </label>
                <!-- <b-form-input
                  type="text"
                  placeholder="Enter your Opening Month"
                  autocomplete="off"
                  v-model="cardData.openingmonth"
                ></b-form-input> -->
                 <model-list-select :list="monthlist" option-value="name" :custom-text="monthName" v-model="openingmonth" placeholder="Select Month" @input="onSelectMonth($event)" @searchchange="searchmonths" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
              </b-form-group>
              <small  class="form-text text-muted"><strong style="color: red;">{{haserror.month}}</strong></small>
            </b-col>
            
              <b-col sm="4"  v-if="cardData.schemerefbenifit!=''">
               
              <b-form-group >
                <label for="name"> Refernce Customer Name </label>
                  <span style="display: flex;">
                 <model-list-select :list="customername" option-value="customer_id" :custom-text="nameAndnumber" v-model="refernce_cust" placeholder="Search Customer Name"  @searchchange="searchcustomer" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                 <!-- <model-list-select :list="customername" option-value="customer_id" :custom-text="nameAndnumber" v-model="cardData.customername" placeholder="Search Customer Name" @input="onSelectCust($event)" @searchchange="searchcustomer" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select> -->
                <!-- <b-form-input
                  type="text"
                  placeholder="Enter your Customer Name"
                  autocomplete="off"
                  v-model="cardData.customername"
                ></b-form-input> -->
                 <button  type="button" class="btn btn-pill btn-primary" route v-b-tooltip.hover title="Add New Customer" @click="addCustomer()">
                     <i class="fa fa-user"></i>
                   </button>
                  </span>
              </b-form-group>
              <small  class="form-text text-muted"><strong style="color: red;">{{haserror.cust}}</strong></small>
            </b-col>
             <b-col sm="2">
              <b-form-group>
                <label for="name"> Date </label>
                <date-picker
                v-if="super_user == 1"
                    editable
                    lang="en"
                     v-model="cardData.created_date"
                  ></date-picker>
                    <date-picker
                    v-else
                    editable
                    lang="en"
                     v-model="cardData.created_date"
                     disabled
                  ></date-picker>
              </b-form-group>
            </b-col>
            
          </b-row> 
          <b-row>
          <b-col sm="12">
            <b-button-group>
              <b-button class="d-sm-down-none btn-sm" @click.prevent="cardPost()" variant="primary"><i class="fa fa-dot-circle-o"></i> Save</b-button>
            </b-button-group>
          </b-col>
        </b-row>
          <!-- <div>
            <vue-good-table
            :columns="columns"
            :rows="rows"/>
            </div>   -->      
        </b-card-body> 
      </b-collapse>
    </b-card>

    <Spinner v-if="loading"></Spinner>
  </div>


</template>


<style>
.switch.switch-text .switch-label::before,
.switch.switch-text .switch-label::after {
  width: 67% !important;
}
.switch.switch-text {
  width: 74px;
}
.switch.switch-text .switch-input:checked ~ .switch-handle {
  left: 50px;
}
.switch.switch-text .switch-label {
  background-color: red;
}
.selected_row {
  background-color: blue;
}
.modal-title {
  color: black;
  font-weight: bold;
}
</style>

<script>
import Spinner from "../../spinner.vue";
import DatePicker from "vue2-datepicker";
export default {
  name: 'my-component',
   components: {
    "date-picker": DatePicker,
    Spinner,
  },
  data(){
    return {
       super_user:3,
       customername:[],
       resss:[],
       monthlist:[],
       shopname:[],
       schemelist:[],
       selectedcustomer:null,
       refernce_cust:null,
       openingmonth:null,
       loading:false,
       select_shop:null,
       selectedscheme:null,
       haserror:{
          month:'',
          shop:'',
          cust:'',
          scheme:'',
          amount :'',
          message:'',
          inclusive:'',
          shop:''
        },
      columns: [
        {
          label: 'month',
          field: 'month',
        },
        {
          label: 'paymonthly',
          field: 'paymonthly',
          type: 'number',
        },
        {
          label: 'Date',
          field: 'Date',
        },
      ],
         cardData:{
                    ledgerno:'',
                    monthlypay:'',
                    address:'',
                    message:'',
                    schemeMonths:'',
                    startMonth:'',
                    schemerefbenifit:'',
                    created_date:new Date().toISOString().slice(0,10)


                }        
    };
  },
  created(){
    this.searchcustomer();
    this.searchscheme();
    this.searchshops();
    this.searchmonths();
  },
  methods:{
    searchmonths(){
       var _this = this
          var myObj =[
	{
    "id":"1",
		"abbreviation": "Jan",
		"name": "January"
	},
	{
    "id":"2",
		"abbreviation": "Feb",
		"name": "February"
	},
	{
    "id":"3",
		"abbreviation": "Mar",
		"name": "March"
	},
	{
    "id":"4",
		"abbreviation": "Apr",
		"name": "April"
	},
	{
    "id":"5",
		"abbreviation": "May",
		"name": "May"
	},
	{
    "id":"6",
		"abbreviation": "Jun",
		"name": "June"
	},
	{
    "id":"7",
		"abbreviation": "Jul",
		"name": "July"
	},
	{
    "id":"8",
		"abbreviation": "Aug",
		"name": "August"
	},
	{
    "id":"9",
		"abbreviation": "Sep",
		"name": "September"
	},
	{
    "id":"10",
		"abbreviation": "Oct",
		"name": "October"
	},
	{
    "id":"11",
		"abbreviation": "Nov",
		"name": "November"
	},
	{
    "id":"12",
		"abbreviation": "Dec",
		"name": "December"
	}
];
_this.monthlist= myObj
        },
    searchcustomer(){
        var _this = this
        this.$http.get('/api/customers').then(function (response) {
          _this.customername = response.data
        }).catch(function (error) {
        });
      },
      searchscheme(){
        var _this = this
        this.$http.get('/api/goldschemes').then(function (response) {
          _this.schemelist = response.data
           _this.super_user = _this.$store.getters.get_super_user;
           console.log("He"+_this.super_user)
        }).catch(function (error) {
        });
      },
      onSchemeChange(option){
        this.haserror.scheme = ''
        this.cardData.monthlypay = option.monthly_pay
        this.cardData.schemeMonths= option.scheme_months
        this.cardData.schemerefbenifit = option.scheme_ref_benifit
        this.refernce_cust = null
      },
      nameAndnumber (item) {
        return `${item.cust_cmp_name} - ${item.cust_cmp_phone}`
      },
      monthName(item)
      {
          return `${item.name}`
      },
      // nameAndnumber1 (item) {
      //   return `${item.name} - ${item.name}`
      // },
      onSelectCust(option1){
         this.haserror.cust = ''
        // console.log(option1.cust_cmp_name)
        this.cardData.address=option1.address1
      },
       onSelectMonth(option1){
          this.haserror.month = ''
          this.cardData.startMonth = option1.id
         // console.log(option1.id)
          
      },
      searchshops(shop_id){
        var _this = this
        this.$http.get('/api/shopusers/getShop').then(function (response) {
          _this.shopname = response.data
          if(shop_id === undefined){
            for (var i = 0; i < response.data.length; i++) {
              if(response.data.length == i+1){
                _this.selectshop = response.data[i]
                if(_this.selectshop.saleprice === true){
                  _this.saleprice_editable = true
                  _this.saleprice_nonedit = false
                }
                else{
                  _this.saleprice_nonedit = true
                  _this.saleprice_editable = false
                }
                _this.company_data();
              }
            }
          }
          else{
            var select_shp = _this.shopname.filter(function(each){
              return each.est_shop_id === shop_id
            });
            _this.selectshop = select_shp[0]
            if(_this.selectshop.saleprice === true){
              _this.saleprice_editable = true
              _this.saleprice_nonedit = false
            }
            else{
              _this.saleprice_nonedit = true
              _this.saleprice_editable = false
            }
            _this.company_data();
          }
        }).catch(function(er){
          console.log(er)
        })
      },

       company_data(){
        this.company_gst = this.selectshop.shop_gst
      },
      onShpChange(option){
         this.haserror.shop = ''
      
      },
      addCustomer(){
        var _thiss = this
        this.loading = true;
        this.$http.get('/api/customers/chk_plan_count').then(function(response){
          _thiss.loading = false;
          if('message' in response.data){
            if(response.data.message === true){
              _thiss.plan_modal = true
            }
            else{
               var params = {}
               var country_id = '101';
               var state_id = '22';
               var city_id = '2707';
               var _this = _thiss
                _this.$http.get('/api/countries').then(function(countries){
                  params["conopt"] = countries.data;
                  // var __this = _this
                  _this.$http.get('/api/companytypes').then(function(response){
                      params["contyp"] = response.data;
                      // var _tthis = __this
                      _this.$http.get('/api/countries/'+country_id).then(function(sel_con){
                        params["con"] = sel_con.data
                        _this.$http.get('/api/states?&filter[where][country_id]='+country_id).then(function(stateopt){
                          params["stateopt"] = stateopt.data;
                          _this.$http.get('/api/states/'+state_id).then(function(sel_state){
                            params["state"] = sel_state.data
                           _this.$http.get('/api/cities?filter[where][state_id]='+state_id).then(function(cityopt){
                             params["cityopt"] = cityopt.data;
                            _this.$http.get('/api/cities/'+city_id).then(function(sel_city){
                                params["city"] = sel_city.data
                                _this.$addcustomermodal.showCustomer(params);
                                // var ___this = _tthis
                                var timer = setInterval(function(){
                                var modal_return = _this.$store.getters.get_custmodal;
                                if(modal_return !== null){
                                  // __this.selectshop = modal_return  
                                  _this.customername.push(modal_return)
                                  _this.selectedcustomer = modal_return
                                  _this.onSelectCust(modal_return)
                                  clearInterval(timer);
                                }
                              }, 1000);
                             }).catch(function(error){
                              console.log(error)
                            })
                            }).catch(function(error){
                            console.log(error)
                          })
                          }).catch(function(error){
                          console.log(error)
                          });
                        }).catch(function(error){
                        console.log(error)
                        });
                      }).catch(function(error){
                        console.log(error)
                      });
                  }).catch(function(err){
                    console.log(err)
                  });
                }).catch(function(error){
                  console.log(error)
                });
			      }
          }
          else{
            console.log('something went wrong')
          }
          }).catch(function(error){
            console.log(error)
          });
       
      },
       addShop(){
        var _this=this
        this.loading = true;
        this.$http.get('/api/shopestablishments/chk_plan_count').then(function(response){
          // opee.log(response.data.message)
          _this.loading = false;
          if('message' in response.data){
            if(response.data.message === true){
              _this.shopplan_modal = true
            }
            else{
               _this.shopplan_modal = false
              var params = {}
              _this.$http.get('/api/countries').then(function(countries){
                params['countries'] = countries.data
                _this.$addshopmodal.showShop(params);
                var __this = _this
                var timer = setInterval(function(){
                var modal_return = __this.$store.getters.get_shopmodal;
                if(modal_return !== null){
                      // __this.selectshop = modal_return  
                      __this.searchshops(modal_return)
                      clearInterval(timer);
                    }
                  }, 1000);
              }).catch(function(error){
                console.log(error)
              });
			      }
          }
          else{
            console.log('something went wrong')
          }
          }).catch(function(error){
            console.log(error)
          });
        
    },
      cardPost(){ 
        var _this = this
        this.haserror.message=''
        
        this.submit_true=0;
        //this.onComplete('check')
        // var formData = new FormData();
        // _this.hasErrors.brandlogo=false;
        // const fileInput = document.querySelector('#image');
      if (this.submit_true==0){
          this.loading=true
          //this.largeModal=false;
           if(this.select_shop==null || this.select_shop.est_shop_id === undefined){
              _this.loading=false;
            this.haserror.shop="Please Select Shop"
          }else if(_this.selectedscheme==null || _this.selectedscheme.scheme_id === undefined){
               _this.loading=false;
              _this.haserror.scheme="Please Select Scheme"
              } else if(_this.cardData.monthlypay=='0.0000' || _this.cardData.monthlypay===undefined){
                
               _this.loading=false;
              _this.haserror.amount="Please Enter Amount"
              }else if(_this.openingmonth==null || _this.openingmonth.name === undefined){
                 _this.haserror.amount=""
               _this.loading=false;
              _this.haserror.month="Please Select Month"
              }else if(_this.selectedcustomer==null || _this.selectedcustomer.customer_id === undefined){
               _this.loading=false;
              _this.haserror.cust="Please Select Customer"
              }else{
                 var user=null;
          _this.submitcardvalue(_this)
              }
         
             }
          },
            submitcardvalue(_this){
               var num = /^[0-9]{1}$/;
              var dateto = new Date(this.cardData.created_date);
              var year = dateto.getFullYear();
              var month = dateto.getMonth() + 1;
              var day = dateto.getDate();
              this.loading = true;
              if (num.test(month) == true) {
                  var month = "0" + month;
              } else {
                  var month = month;
              }
              if (num.test(day) == true) {
                  var day = "0" + day;
              } else {
                  var day = day;
              }
              // var cr_date = year + "-" + month + "-" + day;
               var cr_date = year + "-" + month + "-"+day ;
             
                      if(this.refernce_cust==null){
                        var ref_id =''
                        var total_benifit = '0'
                        
                      }else{
                        var ref_id = this.refernce_cust.customer_id
                        var total_benifit = parseFloat(this.cardData.monthlypay)/100 * parseFloat(this.cardData.schemerefbenifit)
                        // console.log(total_benifit);
                      }
                      let res = {
                          ledger_no: this.cardData.ledgerno,
                          monthly_pay:this.cardData.monthlypay,
                          opening_month:this.openingmonth.name,
                          opening_year:year,
                          customer_id:this.selectedcustomer.customer_id,
                          cust_address:this.cardData.address,
                          est_shop_id:this.select_shop.est_shop_id,
                          scheme_id : this.selectedscheme.scheme_id,
                          created_date : cr_date,
                          total_card_amount : 0,
                          status: 'Open',
                          cust_ref_id:ref_id,
                          cust_ref_id:ref_id,
                          cust_ref_amount :total_benifit
                        }
                        this.$http.post('/api/customercards', res)
                        .then(function (response) {
                        if(response.status==200){
                        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                        var today = new Date(cr_date);/*from ww w .jav a  2s.  co m*/
                        var d;
                        var month;
                        var start_month =  _this.cardData.startMonth - 1 
                        var total_months = _this.cardData.schemeMonths - 1
                        var crd_date = year + "-" + _this.cardData.startMonth + "-26" ;
                        for(var i = 0; i <= total_months; i++) {
                        // d = new Date(today.getFullYear(), today.getMonth() + i, 1);
                         d = new Date(year, start_month + i, 1);
                        month = monthNames[d.getMonth()];
                        var dat = new Date(crd_date);
                        dat.setMonth(dat.getMonth() + i );
                        
                        var due_date = dat.toISOString().replace(/T/, ' ').replace(/\..+/, '')

                         var daueto = new Date(due_date);
              var year1 = daueto.getFullYear();
              var month1 = daueto.getMonth() + 1;
              var day1 = daueto.getDate();
              if (num.test(month) == true) {
                  var month1 = "0" + month1;
              } else {
                  var month1 = month1;
              }
              if (num.test(day1) == true) {
                  var day1 = "0" + day1;
              } else {
                  var day1 = day1;
              }
              // var cr_date = year + "-" + month + "-" + day;
               var duedate = year1 + "-" + month1 + "-"+ day1 ;
               
                         let ress = {
                           customer_id:response.data.customer_id,
                          est_shop_id:response.data.est_shop_id,
                          ig_card_id:response.data.id,
                          pay_month: month+"-"+d.getFullYear(),
                          month_id : i+1,
                          pay_monthly : 0,
                          due_date : duedate ,
                          payment_status:'FALSE'                  
                        }
                       _this.resss = ress
                       _this.$http.post('/api/customermonthentries', ress)
                      .then(function (response) {    
                      if(response.status==200){
                      _this.loading=false;
                      _this.$router.push("/cardlist");
                      }else{
                      console.log('error')
                      }
                    })
                    .catch(function (error) {
                    _this.loading=false
                    console.log(error)
                  });
                }
                let closing_month_year = {
                          //customer_id:response.customer_id,
                          ig_card_id:response.data.id,
                          closing_month: month,
                          closing_year : d.getFullYear(),                         
                        }
               _this.$http.post('/api/customercards/update?where[card_id]='+response.data.id, closing_month_year)
                .then(function (response) {                          
                    if(response.status==200){
                        _this.loading=false;
                        _this.$router.push("/cardlist");  
                    }else{
                      console.log('error')
                    }
                  })
                  .catch(function (error) {
                    _this.loading=false
                    console.log(error)
                  });
               }else{
                console.log('error')
               }
            
                })
                  .catch(function (error) {
                    _this.loading=false
                    console.log(error)
                  });
               },         
              }
            };
</script>



// WEBPACK FOOTER //
// src/views/gold/createcard.vue